module.exports = __webpack_public_path__ + "03_short_brown.1b5431e7.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/male/layer5/03_short_brown.png
// module id = TSBF
// module chunks = 0